(() => {
  function init(root) {
    if (!root || root.dataset.ckReady) return;
    root.dataset.ckReady = 'true';
    const menuButton = root.querySelector('.ck-menu-toggle');
    const menu = root.querySelector('#ck-mobile-menu');
    function closeMenu() {
      if (!menu || !menuButton) return;
      menu.hidden = true;
      menuButton.setAttribute('aria-expanded', 'false');
      menuButton.setAttribute('aria-label', 'Open menu');
    }
    menuButton?.addEventListener('click', () => {
      const expanded = menuButton.getAttribute('aria-expanded') === 'true';
      menu.hidden = expanded;
      menuButton.setAttribute('aria-expanded', String(!expanded));
      menuButton.setAttribute('aria-label', expanded ? 'Open menu' : 'Close menu');
    });
    menu?.querySelectorAll('a').forEach(a => a.addEventListener('click', closeMenu));
    root.addEventListener('keydown', e => { if (e.key === 'Escape') closeMenu(); });
    const track = root.querySelector('.ck-product-track');
    const dots = [...root.querySelectorAll('.ck-page-dots span')];
    root.querySelectorAll('[data-slide]').forEach(button => {
      button.addEventListener('click', () => track?.scrollBy({left: Number(button.dataset.slide) * (track.clientWidth * .8), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'}));
    });
    track?.addEventListener('scroll', () => {
      const remaining = track.scrollWidth - track.clientWidth;
      const active = remaining > 0 ? Math.round(track.scrollLeft / remaining * (dots.length - 1)) : 0;
      dots.forEach((dot, index) => dot.classList.toggle('is-active', index === active));
    }, {passive:true});
    root.querySelectorAll('.ck-expert-toggle').forEach(button => {
      button.addEventListener('click', () => {
        const card = button.closest('.ck-expert');
        const flipped = card.classList.toggle('is-flipped');
        card.querySelector('.ck-expert-front').inert = flipped;
        card.querySelector('.ck-expert-back').inert = !flipped;
        card.querySelectorAll('.ck-expert-toggle').forEach(b => b.setAttribute('aria-expanded', String(flipped)));
        card.querySelector(flipped ? '.ck-expert-back button' : '.ck-expert-front button')?.focus({preventScroll:true});
      });
    });
    root.querySelectorAll('.ck-expert-back').forEach(back => {back.inert = true;});
    const previewForm = root.querySelector('[data-preview-newsletter]');
    previewForm?.addEventListener('submit', event => {
      event.preventDefault();
      const status = root.querySelector('[data-preview-form-status]');
      status.hidden = false;
      status.textContent = 'This preview does not submit email addresses.';
    });
    if (window.lucide) window.lucide.createIcons();
  }
  const initialize = () => document.querySelectorAll('[data-catak-home]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:block:select', event => {
    const card=event.target.closest?.('.ck-expert');
    if(card){card.classList.remove('is-flipped');card.querySelector('.ck-expert-front').inert=false;card.querySelector('.ck-expert-back').inert=true;}
  });
})();
